import { useEffect, useState } from "react";
import { Pagination } from "react-pagination-bar";

function CustomPaginate({
  tableData,
  setCurrentLists,
  currentList,
  totalElements,
}: any) {
  const [pageTable, setpageTable] = useState(1);

  function paginate(
    array: Array<object>,
    page_size: number,
    page_number: number
  ): Array<object> {
    return array.slice((page_number - 1) * page_size, page_number * page_size);
  }

  useEffect(() => {
    if (!currentList) return;
    if (currentList.length === 0 && pageTable > 1) {
      setpageTable(pageTable - 1);
      setCurrentLists(paginate(tableData, 6, pageTable - 1));
    } else {
      setCurrentLists(paginate(tableData, 6, pageTable));
    }
  }, [pageTable, tableData?.length, currentList?.length]);

  return (
    <div className="Pagination">
      <Pagination
        currentPage={pageTable}
        itemsPerPage={6}
        onPageChange={(pageNumber) => {
          setpageTable(pageNumber);
        }}
        totalItems={totalElements || tableData?.length}
        pageNeighbours={2}
        customClassNames={{
          rpbItemClassNameActive: "pagination_style",
        }}
      />
    </div>
  );
}

export default CustomPaginate;
